import React, { useEffect, useState } from "react";
import { DanhSachTaiSanCombo } from "constants/danhSachTaiSanConst";
import StoreApi from "service/storeApi";

export const SearchBarDesktop = ({ onSearch, setDataSearch, dataSearch }) => {
  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };
  const [dataCombo, setdataCombo] = useState(DanhSachTaiSanCombo.KhoCombo);

  const updateState = (field, text) => {
    setDataSearch({
      ...dataSearch,
      [field]: text,
    });
  };

  useEffect(() => {
    StoreApi.combo({}).then((response) => {
      // console.log(response.data);
      const dataComboReturn = response.data.map((item) => ({
        value: item.value,
        label: item.StoreName,
      }));
      //setdataCombo(dataComboReturn);
      setdataCombo([
        {
          value: 0,
          label: "Kho",
        },
        ...dataComboReturn,
      ]);
    });
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      setDataSearch({
        ...dataSearch,
        pageIndex: 1,
      });
      onSearch(dataSearch);
    }
  };

  return (
    <>
      <div className="search-new  show-table-main">
        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">
            Mã, tên tài sản
          </label>
          <input
            type="text"
            className="form-control input-sm"
            placeholder="Mã, tên tài sản"
            value={dataSearch.maTaiSan}
            onChange={updateTextValue("maTaiSan")}
            onKeyDown={handleKeyDown}
          />
        </div>
        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Kho</label>
          <select
            name="kho"
            className="selectBox form-control input-sm"
            value={dataSearch.kho}
            onChange={updateTextValue("kho")}
          >
            {dataCombo &&
              dataCombo.map((item, idx) => (
                <option key={"objComboStore1" + idx} value={item.value}>
                  {item.label}
                </option>
              ))}
          </select>
        </div>
        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Điều kiện</label>
          <input
            type="text"
            className="form-control input-sm"
            placeholder="so sánh"
            value={dataSearch.soSanh}
            onChange={updateTextValue("soSanh")}
            onKeyDown={handleKeyDown}
          />
        </div>
        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">
            Giá trị tìm kiếm
          </label>
          <input
            type="text"
            className="form-control input-sm"
            placeholder="giá trị tìm kiếm"
            value={dataSearch.giaTriTimKiem}
            onChange={updateTextValue("giaTriTimKiem")}
            onKeyDown={handleKeyDown}
          />
        </div>
        <div className="input-sm-new input-new-18 search-main-new btn-seach-ds">
          <button type="submit" className="btn btn-info-new" onClick={onSearch}>
            <i className="la la-search"></i>
            <span> &nbsp; Tìm kiếm</span>
          </button>
        </div>
      </div>
    </>
  );
};
